import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

export type OffDayTypes = {
  HOLIDAY: number;
  SICK: number;
  PUBLIC_HOLIDAY: number;
  OTHER: number;
};

type OffDaySummaryProps = {
  employeeOffDaySummary: Record<string, OffDayTypes>;
  employeeMap: Record<string, string>;
};

export const OffDaySummary: React.FC<OffDaySummaryProps> = ({
  employeeOffDaySummary,
  employeeMap,
}) => {
  const t = useTranslate();
  return (
    <Table size="sm">
      <Thead>
        <Tr>
          <Th>{t('timeTracking.employees')}</Th>
          <Th>{t('timeTracking.addOffDayPopver.holiday')}</Th>
          <Th>{t('timeTracking.addOffDayPopver.sick')}</Th>
          <Th>{t('timeTracking.addOffDayPopver.publicHoliday')}</Th>
          <Th>{t('timeTracking.addOffDayPopver.other')}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {Object.entries(employeeOffDaySummary)
          .sort(([idA], [idB]) =>
            (employeeMap[idA] || '').localeCompare(employeeMap[idB] || ''),
          )
          .map(([employeeId, types]) => (
            <Tr key={employeeId}>
              <Td>{employeeMap[employeeId] || 'Unknown'}</Td>
              <Td>{types.HOLIDAY}</Td>
              <Td>{types.SICK}</Td>
              <Td>{types.PUBLIC_HOLIDAY}</Td>
              <Td>{types.OTHER}</Td>
            </Tr>
          ))}
      </Tbody>
    </Table>
  );
};
